const links = document.querySelectorAll(".faq__navigation-button");

function getTotalNavHeight() {
  let navHeight = document.querySelector(".outer-header-wrapper").clientHeight;
  let faqNavHeight = document.querySelector(".faq__navigation").clientHeight;
  let totalNavHeight = navHeight + faqNavHeight;

  return [navHeight, totalNavHeight];
}

function setStickyPosition() {
  let totalNavHeight = getTotalNavHeight();
  document.querySelector(".faq__navigation").style.top = `${
    totalNavHeight[0] - 2
  }px`;
}

let totalNavHeight = getTotalNavHeight();

window.addEventListener("resize", (event) => setStickyPosition());
window.addEventListener("DOMContentLoaded", (event) => setStickyPosition());

// Highlight on scroll
window.addEventListener("scroll", (event) => {
  const fromTop = window.scrollY;

  links.forEach((link) => {
    const section = document.querySelector(
      `.faq__component[data-section="${link.dataset.section}"]`
    );

    if (section) {
      if (
        section.offsetTop - totalNavHeight[1] <= fromTop &&
        section.offsetTop - totalNavHeight[1] + section.clientHeight > fromTop
      ) {
        link.classList.add("active");
      } else {
        link.classList.remove("active");
      }
    }
  });
});

// Scroll to link
links.forEach((link) => {
  link.addEventListener("click", (event) => {
    event.preventDefault();
    const section = document.querySelector(
      `.faq__component[data-section="${event.currentTarget.dataset.section}"]`
    );

    window.scrollTo({
      top: section.offsetTop - totalNavHeight[1],
      behavior: "smooth",
    });
  });
});

/*================ FAQ Component ================*/
const faqs = document.querySelectorAll(".faq__item-question");
faqs.forEach((faq) => {
  faq.addEventListener("click", (event) => {
    const parent = event.currentTarget.parentElement;
    const content = parent.querySelector(".faq__item-answer");

    parent.classList.toggle("active");
    slideToggle(content, 300);
  });
});
